import { render, staticRenderFns } from "./Instituciones.vue?vue&type=template&id=621b0072&scoped=true&lang=pug&"
import script from "./Instituciones.vue?vue&type=script&lang=js&"
export * from "./Instituciones.vue?vue&type=script&lang=js&"
import style0 from "./Instituciones.vue?vue&type=style&index=0&id=621b0072&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621b0072",
  null
  
)

export default component.exports